import BaseComponent from '../abstracts/BaseComponent';

export default class InPageLayerComponent extends BaseComponent {
  get Messages() {
    return {
      [this.CUSTOM_MESSAGES.INPAGE_LAYER_EVENTS.close]: this.close
    };
  }


  get SELECTORS() {
    return {
      closeButton: '.js-close-layer'
    };
  }

  get CLASSES() {
    return {
      active: 'active',
      animate: 'animate',
      visible: 'visible'
    };
  }

  constructor(element) {
    super(element);
    this.handleClick();
  }


  handleClick() {
    this.$on('click.InPageLayerComponent', (e) => {
      const target = document.querySelector(this.$options.target);
      // window.scrollTo(0, 0);
      this.$el.classList.add(this.CLASSES.active);
      target.classList.add(this.CLASSES.visible);
      this.timeout = setTimeout(() => {
        target.classList.add(this.CLASSES.animate);
      }, 200);

      this.handleCloseClick(target);
    });
  }

  handleCloseClick(target) {
    const closeButton = target.querySelector(this.SELECTORS.closeButton);

    this.$off('click.closeInPageLayer', closeButton);
    this.$on('click.closeInPageLayer', () => {
      this.$el.classList.remove(this.CLASSES.active);
      target.classList.remove(this.CLASSES.animate);
      this.timeout = setTimeout(() => {
        target.classList.remove(this.CLASSES.visible);
      }, 100);
    }, closeButton);
  }
}
